import severity from '@sharedModules/data/enums/validation-severity';

export const severityOrder = Object.values(severity);
export default severity;
